//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { Router } from '@angular/router';
//app
import { AppAnimations } from '../../../../../../_shared/animations';
import { AppData, responseCode } from '../../../../../../app.data';
import { KeyName } from 'src/app/app.keynames';
import { CompanySMTPSettings } from '../../../../../../_shared/models/company.model';
import { LoaderService } from '../../../../../../_core/services';
import { RestResponse } from 'src/app/_shared/models';
import { SettingsService } from '../../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'app-smpt-setting',
  templateUrl: './smpt-setting.component.html'
})

export class SmtpSettingComponent implements OnInit, OnDestroy {
  form: FormGroup;
  formSubmitted: boolean = false;
  hidePassword: boolean = true;
  resSuccess: boolean;
  statusLoader: number = 1;
  isFormReady: boolean = false;
  private subs = new Unsubscriber();

  constructor(
    private _data: AppData,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _meta: MetaService,
    private _router: Router,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService
  ) {
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this.form = new FormGroup({
      smtpServerAddress: new FormControl('', [Validators.required]),
      smtpUserName: new FormControl('', [Validators.required]),
      smtpPassword: new FormControl('', [Validators.required]),
      smtpPortNumber: new FormControl('', [Validators.required]),
      smtpEncryptionType: new FormControl('ssl', [Validators.required]),
    })
  }

  getSMTPSettings() {
    //Get Company Details filtered by entityId
    this.subs.addSub = this.settingsService.getSMTPSettings().subscribe(
      (res:RestResponse) => {
        // REVCODREB: It is necessary create an entity for smtp config.
        let smtpConfig: CompanySMTPSettings = new CompanySMTPSettings().deserialize(res.data);
        this.form.patchValue(smtpConfig);
        this.resSuccess = res.isSuccess;
        this.isFormReady = true;
      },
      (err:RestResponse) => {
        this.resSuccess = err.isSuccess;
        this.isFormReady = true;
        this._meta.showNotification(err);
      }
    )
  }

  ngOnInit() {
    this.getSMTPSettings();
  }

  onSubmit(){
    this.formSubmitted = !this.formSubmitted;

    // Check if form is valid.
    if (this.form.valid){
      this.subs.addSub = this.settingsService.updateEmailSettings(this.form.value).subscribe(
        (res:RestResponse) => {
          this._meta.showNotification(res);
          this._router.navigate(['/main/settings/emails']);
        },
        (err:RestResponse) => {
          this.formSubmitted = !this.formSubmitted;
          this._meta.showNotification(err);
        }
      );
    } else {
      this.formSubmitted = !this.formSubmitted;
      this._meta.showNotificationCustomMessage(responseCode.errorBadRequestCode, KeyName.form_invalid);
    }


  }

  /** REVCODEREB: verificar que esta funcion llama a algo que no se esta utilizando */
  encriptionType(e) {
    this.form.controls['smtpSettings'].get('encriptionType').setValue(e.target.value)
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
